import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const CUSTOMER_SAP_EXPORT_DELETE_RESOURCE = "customer-sap-export" as const;
export const CUSTOMER_SAP_EXPORT_DELETE_API_PATH = `/v1/${CUSTOMER_SAP_EXPORT_DELETE_RESOURCE}/{uuid}` as const;

export const useCustomerSapExportDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      await alphartisApiAxios.delete<void>(`/v1/${CUSTOMER_SAP_EXPORT_DELETE_RESOURCE}/${uuid}`);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [CUSTOMER_SAP_EXPORT_DELETE_RESOURCE],
      });
    },
  });
};
